export default __webpack_public_path__ + "images/assets/dbbb021cd8860176630f45b320c6627d.svg";